export default "__VITE_ASSET__Bb3MRvmn__"